import styled from 'styled-components';

export const StyledKakarikoForm = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  min-width: 400px;
  padding: 0;

  > div {
    grid-column: span 2;
    padding: 8px;

    .composed {
      margin: -8px;
    }
  }
`;
